// extracted by mini-css-extract-plugin
export var boxItems = "_b4-1";
export var boxItemsLg = "_b4-2";
export var button = "_b4-7";
export var buttonHoverless = "_b4-9";
export var buttonLg = "_b4-8";
export var filterGroupBox = "_b4-0";
export var icon = "_b4-3";
export var iconSecondary = "_b4-6";
export var iconWrapper = "_b4-4";
export var iconWrapperLg = "_b4-5";
export var truncatedLabel = "_b4-a";